import { useAppSelector } from '@/redux/hooks'
import { Base, SuccessIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useSendProductRequest } from '@/application/send-product-request'

const Suggestions = () => {
  const { t } = useTranslation()
  const email =
    useAppSelector((store) => store.userApi.getMe.response.user?.name) ?? ''

  const [inputText, setInputText] = useState('')
  const { sendProductRequest, isLoading, error, success } =
    useSendProductRequest()

  const handleClickRequest = () => {
    sendProductRequest({
      email,
      featureText: inputText,
      source: 'store'
    })
  }
  return (
    <div className="mt-3 grid w-full grid-cols-3 gap-3">
      <div className="col-span-1 col-start-2 w-full rounded-xl bg-white px-2 py-4 shadow">
        <h5 className="mt-2 text-center text-xl font-bold text-gray-800">
          Any other suggestion?
        </h5>
        <h6 className="text-center text-base font-light text-gray-600">
          We want to hear you
        </h6>
        <div className="mt-4 flex items-center justify-center">
          <div className="flex w-full flex-col gap-2 px-2">
            <textarea
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              className="h-24 w-full rounded-xl border border-solid border-gray-200 p-3 text-base"
              placeholder="We need you to implement time travel to retrieve items that haven't even been purchased yet..."
            />
            {isLoading ? (
              <div className="flex w-full items-center justify-center">
                <Base.Spinner
                  label={t('rever_store.sending_request')}
                  className="m-2 mt-4"
                />
              </div>
            ) : success ? (
              <div className="-ml-2 flex w-full items-center justify-center">
                <SuccessIcon className="m-2 size-4" />
                <p className="text-sm font-thin text-gray-400">Request sent</p>
              </div>
            ) : error ? (
              <div className="flex w-full items-center justify-center text-red-500">
                <p className="text-sm font-thin">
                  Something went wrong. Please try again.
                </p>
              </div>
            ) : (
              <button
                onClick={handleClickRequest}
                className="font-base mx-auto mt-2 w-fit rounded-full border border-solid border-gray-300 px-8 py-1 text-sm text-gray-600 transition-all hover:bg-gray-100 hover:shadow"
              >
                <p>Request</p>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Suggestions
